import { useEffect } from "react";
import { useBranch } from "../../../hooks/branches/useBranch";
import { useCashRegister } from "../../../hooks/cash/useCashRegister";

import FormModal from "../../Modals/FormModal";
import CashRegisterForm from "./CashRegisterForm";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  registerId: number | null;
}

const CashRegisterEditPopup = ({ isOpen, onClose, registerId }: Props) => {

  const {
    form,
    fetchRegisterById,
    updateRegister
  } = useCashRegister();

  const { branchDropdown, fetchBranchDropdown } = useBranch();

  useEffect(() => {

    if (isOpen && registerId) {
      fetchRegisterById(registerId);
      fetchBranchDropdown();
    }

  }, [isOpen, registerId]);

  const handleSubmit = async (data: any) => {

    if (!form.id) return;

    await updateRegister(form.id, data);

    onClose();
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Editar Terminal POS"
      maxWidth="max-w-3xl"
      overlayBg="black"
      zIndex="front"
    >
      <CashRegisterForm
        onSubmit={handleSubmit}
        branchOptions={branchDropdown}
      />
    </FormModal>
  );
};

export default CashRegisterEditPopup;